import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FrontpageComponent } from './components/frontpage/frontpage.component';
import { MultimodalComponent } from './components/multimodal/multimodal.component';

import { AudioService } from './services/audio.service';
import { ContentService } from './services/content.service';
import { DrawingService } from './services/drawing.service';
import { VoiceControlService } from './services/voice-control.service';
import { CursorService } from './services/cursor.service';
import { NavigationComponent } from './components/navigation/navigation.component';
import { FooterComponent } from './components/footer/footer.component';
import { PublicationsComponent } from './components/publications/publications.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { TeachingComponent } from './components/teaching/teaching.component';
import { MultimodalService } from './services/multimodal.service';
import { ContactComponent } from './components/contact/contact.component';
import { DrawingContactService } from './services/drawing-contact.service';
import { NavigatorService } from './services/navigator.service';
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    FrontpageComponent,
    MultimodalComponent,
    NavigationComponent,
    PublicationsComponent,
    TeachingComponent,
    ContactComponent,
    FooterComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    InlineSVGModule.forRoot()
  ],
  providers: [
    ContentService,
    DrawingService,
    DrawingContactService,
    CursorService,
    VoiceControlService,
    AudioService,
    MultimodalService,
    NavigatorService,
    {provide : LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
